import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_KIEMKHO } from "../actions/KiemKho/actionTypes";
import {
  getListKiemKhoSuccess,
  getListKiemKhoFailure,
} from "../actions/KiemKho";
import KiemKhoApi from "../service/kiemKhoApi";

function* getListKiemKho(action) {
  try {
    const response = yield call(KiemKhoApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListKiemKhoSuccess(response.data));
    } else {
      yield put(getListKiemKhoFailure());
    }
  } catch (error) {
    yield put(getListKiemKhoFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_KIEMKHO, getListKiemKho);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
